// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-layout-ModalView-ModalView-module__container-mGeutA","background":"src-app-components-layout-ModalView-ModalView-module__background-t1BBcY","contents":"src-app-components-layout-ModalView-ModalView-module__contents-Y9vbAl","visible":"src-app-components-layout-ModalView-ModalView-module__visible-GOazQf"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-layout-ModalView-ModalView-module__container-mGeutA\",\"background\":\"src-app-components-layout-ModalView-ModalView-module__background-t1BBcY\",\"contents\":\"src-app-components-layout-ModalView-ModalView-module__contents-Y9vbAl\",\"visible\":\"src-app-components-layout-ModalView-ModalView-module__visible-GOazQf\"}";
        // 1789362522821
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  